import { status } from '../../helpers'

const getShopifyStoreDefaultState = () => {
  return {
    loadShopifyOrders: status.INITIALIZED,
    loadShopifyFees: status.INITIALIZED,
    orders: {},
    fees: {}
  }
}

export default getShopifyStoreDefaultState
